import { Check, X } from "lucide-react";
import { get, startCase } from "lodash";

import { selectColumn } from "components/BaseTableV3/selectColumn";
import RuvixxDate from "components/RuvixxDate";
import { TableLink } from "components/BaseTableV3/TableLink";
import { getUsersForFiltersQuery } from "helpers/user";
import { CustomFieldConfigTableActions } from "routes/custom_field/components/custom_field_config_table/CustomFieldConfigTableActions";

const fieldTypeOptions = [
  {
    id: "text",
    name: "Text",
  },
  {
    id: "numeric",
    name: "Numeric",
  },
  {
    id: "boolean",
    name: "Boolean",
  },
  {
    id: "select",
    name: "Categorical",
  },
  {
    id: "date",
    name: "Date",
  },
  {
    id: "list",
    name: "List",
  },
];

export const getCustomFieldConfigTableColumns = () => {
  return [
    selectColumn,
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      width: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original?.id}</p>
      ),
    },
    {
      header: "Label",
      id: "Label",
      accessorKey: "label",
      cell: ({ row }) => (
        <TableLink href={`/settings/custom_field_configs/${row.original.id}`}>
          {row.original.label}
        </TableLink>
      ),
    },
    {
      header: "Field Type",
      id: "Field Type",
      accessorKey: "field_type",
      cell: ({ row }) => {
        if (row.original?.field_type === "select") {
          return <p>Categorical</p>;
        } else {
          return <p>{startCase(row.original?.field_type)}</p>;
        }
      },
    },
    {
      header: "Model Type",
      id: "Model Type",
      accessorKey: "model_type",
    },
    {
      header: "Required",
      id: "Required",
      accessorKey: "required",
      cell: ({ row }) =>
        row.original?.required ? (
          <Check
            className="tw:size-4 tw:text-[#24B388]"
            aria-label="Required"
          />
        ) : (
          <X
            className="tw:text-destructive tw:size-4"
            aria-label="Not required"
          />
        ),
    },
    {
      header: "Description",
      id: "Description",
      accessorKey: "description",
    },
    {
      header: "Field Options",
      id: "Field Options",
      accessorKey: "field_options",
      enableSorting: false,
      cell: ({ row }) => <p>{get(row, "original.field_options.type", "--")}</p>,
    },
    {
      header: "Created By",
      id: "Created By",
      accessorKey: "created_by_user.full_name",
      enableSorting: false,
      cell: ({ row }) => (
        <p>{row.original?.created_by_user?.full_name || "—"}</p>
      ),
    },
    {
      header: "Created At",
      id: "Created At",
      accessorKey: "created_at",
      cell: ({ row }) => <RuvixxDate date={row.original?.created_at} />,
    },
    {
      header: "Updated By",
      id: "Updated By",
      accessorKey: "updated_by_user.full_name",
      enableSorting: false,
      cell: ({ row }) => (
        <p>{row.original?.updated_by_user?.full_name || "—"}</p>
      ),
    },
    {
      header: "Updated At",
      id: "Updated At",
      accessorKey: "updated_at",
      cell: ({ row }) => <RuvixxDate date={row.original?.updated_at} />,
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <CustomFieldConfigTableActions original={row.original} />
      ),
    },
  ];
};

export const getCustomFieldConfigTableFilters = ({ modelTypeOptions }) => {
  return [
    {
      key: "model_type",
      title: "Model Type",
      type: "select",
      data: modelTypeOptions,
    },
    {
      key: "field_type",
      title: "Field Type",
      type: "select",
      data: fieldTypeOptions,
    },
    {
      key: "creator_user_id",
      title: "Created By",
      type: "ruvixxSelect",
      queryFn: getUsersForFiltersQuery,
    },
  ];
};
